export const isEeUI: boolean = true
